import React, { useEffect, useRef, useState } from "react";
import { NavLink, Routes, Route, useNavigate } from "react-router-dom";

import {
  FaHome, FaUsers, FaShoppingCart, FaBoxOpen, FaFileInvoice, FaBell,
  FaChartBar, FaUserShield, FaAddressBook, FaAngleDown, FaUserCircle, FaTable
} from "react-icons/fa";

// Pages
import Home from "./Home";
import LeadManagement from "./LeadManagement";
import CustomerManagement from "./CustomerManagement";
import ProductMaster from "./ProductMaster";
import SalesOrders from "./SalesOrders";
import Invoicing from "./Invoicing";
import UserRoles from "./UserRoles";
import Logout from "./Logout";
import InventoryMaster from "./InventoryMaster";
import MasterGst from "./MasterGst";
import SalesOrderList from "./SalesOrderList";
import Followups from "./Followups";
import InvoicingList from "./InvoicingList";
import CategoryPage from "./CategoryPage";

import "./Dashboard.css";
import Reports from "./Reports";
import ClothingSheetList from "./ClothingSheetList";
import SheetsMaster from "./SheetsMaster";
import Invoicingvsm from "./Invoicingvsm";
import InvoicesListVsm from "./invoicesListVsm";

function Dashboard() {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [openDropdown, setOpenDropdown] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);
  const isLoggedOut = useRef(false);

  const navigate = useNavigate();
  const handleLogout = () => {
    alert('You have been logged out successfully.');
    sessionStorage.clear();
    isLoggedOut.current = true;
    window.history.pushState(null, '', window.location.href);
    navigate('/login');
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? "" : name);
  };

  useEffect(() => {
    const savedLogo = sessionStorage.getItem("company_logo");
    if (savedLogo) setLogo(savedLogo);
  }, []);

  // Load userData and logo safely
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const isCompany = userData?.type === "company";
  const permissions = userData?.permissions || {};
  const [logo, setLogo] = useState(userData?.company_logo || sessionStorage.getItem("company_logo") || null);

  useEffect(() => {
    const savedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    const savedLogo = savedUserData?.company_logo || sessionStorage.getItem("company_logo");
    if (savedLogo) {
      setLogo(savedLogo);
    }
  }, []);


  const canAccess = (key) => {
    if (isCompany) return true;
    return permissions[key] === 1;
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="dashboard">
      <aside className={`sidebar ${isMobile ? (isOpen ? "expanded" : "") : "expanded"}`}>
        <div className="top-section mobile-top">
          <div className="logo-area" onClick={() => { if (window.innerWidth <= 768) { setIsOpen(true); } }}
            style={{ cursor: "pointer" }}>
            {isOpen && logo && <img src={logo} alt="logo" className="brand-logo" />}
            {isOpen && !logo && <h2 className="logo-text">LOGO</h2>}
          </div>
          <button className="mobile-close" onClick={() => setIsOpen(false)} style={{ color: 'black' }}>✕</button>
        </div>

        {/* Sidebar Navigation with Small Font Styling */}
        <nav className="menu" style={{ fontSize: "13px" }}>
          {canAccess("dashboard") && (
            <NavLink to="/dashboard/home" className="menu-item" onClick={() => window.innerWidth <= 768 && setIsOpen(false)} style={{ fontSize: "13px" }}>
              <FaHome /> {isOpen && <span>Dashboard</span>}
            </NavLink>
          )}

          {/* Sheets Dropdown with Sheets Master and Sheets List */}
          {/* Sheets / Product Dropdown - Shown when type_seperate is present or VSM */}
          {userData?.type_seperate && (canAccess("sheet_sheet") || isCompany) && (
            <>
              <div className="menu-item dropdown" onClick={() => toggleDropdown("sheets")} style={{ fontSize: "13px", cursor: "pointer" }}>
                <div className="dropdown-header">
                  <FaTable />
                  {isOpen && <span>Product</span>}
                </div>
                {isOpen && <FaAngleDown className={`arrow ${openDropdown === "sheets" ? "rotate" : ""}`} />}
              </div>

              {openDropdown === "sheets" && (
                <div className="dropdown-panel" style={{ fontSize: "12px", paddingLeft: "15px" }}>
                  {/* <NavLink to="/dashboard/category" className="dropdown-link" style={{ fontSize: "12px" }}>Category</NavLink> */}
                  <NavLink to="/dashboard/sheet-sheet" className="dropdown-link" style={{ fontSize: "12px" }}>Product Master</NavLink>
                  <NavLink to="/dashboard/sheet-list" className="dropdown-link" style={{ fontSize: "12px" }}>Product List</NavLink>
                </div>
              )}
            </>
          )}

          {/* Master Dropdown - Hidden completely when type_seperate exists */}
          {!userData?.type_seperate &&
            (canAccess("category") || canAccess("product_master") || canAccess("inventory_master") || canAccess("master_gst")) && (
              <>
                <div className="menu-item dropdown" onClick={() => toggleDropdown("master")} style={{ fontSize: "13px", cursor: "pointer" }}>
                  <div className="dropdown-header">
                    <FaBoxOpen />
                    {isOpen && <span>Master</span>}
                  </div>
                  {isOpen && <FaAngleDown className={`arrow ${openDropdown === "master" ? "rotate" : ""}`} />}
                </div>

                {openDropdown === "master" && (
                  <div className="dropdown-panel" style={{ fontSize: "12px", paddingLeft: "15px" }}>
                    {canAccess("category") && <NavLink to="/dashboard/category" className="dropdown-link" style={{ fontSize: "12px" }}>Category</NavLink>}
                    {canAccess("product_master") && <NavLink to="/dashboard/products" className="dropdown-link" style={{ fontSize: "12px" }}>Product Master</NavLink>}
                    {canAccess("inventory_master") && <NavLink to="/dashboard/inventory" className="dropdown-link" style={{ fontSize: "12px" }}>Inventory Master</NavLink>}
                    {canAccess("master_gst") && <NavLink to="/dashboard/master+gst" className="dropdown-link" style={{ fontSize: "12px" }}>Master GST</NavLink>}
                  </div>
                )}
              </>
            )}

          {canAccess("lead_management") && (
            <NavLink to="/dashboard/leads" className="menu-item" style={{ fontSize: "13px" }}>
              <FaAddressBook /> {isOpen && <span>Lead Management</span>}
            </NavLink>
          )}

          {canAccess("customer_management") && (
            <NavLink to="/dashboard/customers" className="menu-item" style={{ fontSize: "13px" }}>
              <FaUsers /> {isOpen && <span>Customer Management (CRM)</span>}
            </NavLink>
          )}

          {/* Sales / Quotation Dropdown */}

          {userData?.type_seperate && (canAccess("sheet_sheet") || isCompany) && (
            <>
              <div className="menu-item dropdown" onClick={() => toggleDropdown("salesvsm")} style={{ fontSize: "13px", cursor: "pointer" }}>
                <div className="dropdown-header">
                  <FaShoppingCart />
                  {isOpen && <span>Quotation (VSM)</span>}
                </div>
                {isOpen && <FaAngleDown className={`arrow ${openDropdown === "salesvsm" ? "rotate" : ""}`} />}
              </div>

              {openDropdown === "salesvsm" && (
                <div className="dropdown-panel" style={{ fontSize: "12px", paddingLeft: "15px" }}>
                  <NavLink to="/dashboard/invoicingvsm" className="dropdown-link" style={{ fontSize: "12px" }}>Add New Quotation(VSM)</NavLink>
                </div>
              )}
            </>
          )}


          {!userData?.type_seperate && canAccess("sales_order_management") && (
            <>
              <div className="menu-item dropdown" onClick={() => toggleDropdown("sales")} style={{ fontSize: "13px", cursor: "pointer" }}>
                <div className="dropdown-header">
                  <FaShoppingCart />
                  {isOpen && <span>Quotation</span>}
                </div>
                {isOpen && <FaAngleDown className={`arrow ${openDropdown === "sales" ? "rotate" : ""}`} />}
              </div>

              {openDropdown === "sales" && (
                <div className="dropdown-panel" style={{ fontSize: "12px", paddingLeft: "15px" }}>
                  <NavLink to="/dashboard/orders" className="dropdown-link" style={{ fontSize: "12px" }}>Add New Sale</NavLink>
                  <NavLink to="/dashboard/SalesOrderList" className="dropdown-link" style={{ fontSize: "12px" }}>View Sales</NavLink>
                </div>
              )}
            </>
          )}

          {userData?.type_seperate && (canAccess("sheet_sheet") || isCompany) && (
            <>
              <div className="menu-item dropdown" onClick={() => toggleDropdown("invoicingvsm")} style={{ fontSize: "13px", cursor: "pointer" }}>
                <div className="dropdown-header">
                  <FaFileInvoice />
                  {isOpen && <span>Invoicing VSM</span>}
                </div>
                {isOpen && <FaAngleDown className={`arrow ${openDropdown === "invoicingvsm" ? "rotate" : ""}`} />}
              </div>

              {openDropdown === "invoicingvsm" && (
                <div className="dropdown-panel" style={{ fontSize: "12px", paddingLeft: "15px" }}>
                  <NavLink to="/dashboard/invoicingvsm" className="dropdown-link" style={{ fontSize: "12px" }}>New Invoice(VSM)</NavLink>
                  <NavLink to="/dashboard/invoicelistvsm" className="dropdown-link" style={{ fontSize: "12px" }}>Invoice List(VSM)</NavLink>
                </div>
              )}
            </>
          )}

          {/* Invoicing Dropdown */}
          {/* Invoicing Dropdown - Hidden completely when type_seperate exists */}
          {!userData?.type_seperate && canAccess("quotation_invoicing") && (
            <>
              <div className="menu-item dropdown" onClick={() => toggleDropdown("invoice")} style={{ fontSize: "13px", cursor: "pointer" }}>
                <div className="dropdown-header">
                  <FaFileInvoice />
                  {isOpen && <span>Invoicing</span>}
                </div>
                {isOpen && <FaAngleDown className={`arrow ${openDropdown === "invoice" ? "rotate" : ""}`} />}
              </div>

              {openDropdown === "invoice" && (
                <div className="dropdown-panel" style={{ fontSize: "12px", paddingLeft: "15px" }}>
                  <NavLink to="/dashboard/quotations" className="dropdown-link" style={{ fontSize: "12px" }}>New Invoice</NavLink>
                  <NavLink to="/dashboard/invoicelist" className="dropdown-link" style={{ fontSize: "12px" }}>Invoice List</NavLink>
                </div>
              )}
            </>
          )}

          {canAccess("followups_reminders") && (
            <NavLink to="/dashboard/followups" className="menu-item" style={{ fontSize: "13px" }}>
              <FaBell /> {isOpen && <span>Follow-ups</span>}
            </NavLink>
          )}

          {canAccess("reports_analytics") && (
            <NavLink to="/dashboard/reports" className="menu-item" style={{ fontSize: "13px" }}>
              <FaChartBar /> {isOpen && <span>Reports</span>}
            </NavLink>
          )}

          {canAccess("user_roles_permissions") && (
            <NavLink to="/dashboard/roles" className="menu-item" style={{ fontSize: "13px" }}>
              <FaUserShield /> {isOpen && <span>User Roles</span>}
            </NavLink>
          )}


        </nav>
      </aside>

      {/* Header Bar */}
      <header className="header-bar">
        <button className="mobile-toggle" onClick={() => setIsOpen(prev => !prev)} style={{ color: 'black' }}>☰</button>
        <div className="company-name">
          {(JSON.parse(sessionStorage.getItem("userData"))?.company_name || "Company Name").toUpperCase()}
        </div>

        {/* Right Side */}
        <div style={{ position: "relative" }}>
          <button onClick={() => setProfileOpen(!profileOpen)} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "6px", border: "none", background: "transparent", cursor: "pointer", borderRadius: "8px" }}>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "12px", fontWeight: "700", textTransform: "uppercase", color: "#0f172a" }}>
                {JSON.parse(sessionStorage.getItem("userData"))?.name || "User"}
              </div>
              <div style={{ fontSize: "10px", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "1px" }}>
                {(JSON.parse(sessionStorage.getItem("userData"))?.user_type || "User Type").toUpperCase()}
              </div>
            </div>

            <div style={{ width: "34px", height: "34px", backgroundColor: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <FaUserCircle style={{ fontSize: "18px", color: "#475569" }} />
            </div>
          </button>

          {profileOpen && (
            <div style={{ position: "absolute", top: "100%", right: 0, marginTop: "8px", width: "240px", backgroundColor: "#fff", border: "1px solid #000", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.12)", overflow: "hidden", zIndex: 999 }}>
              <div style={{ padding: "12px 16px", borderBottom: "1px solid #e2e8f0" }}>
                <div style={{ fontSize: "11px", fontWeight: "700", color: "#0f172a", marginBottom: "4px" }}>USER EMAIL</div>
                <div style={{ fontSize: "12px", color: "#64748b", wordBreak: "break-word" }}>
                  {JSON.parse(sessionStorage.getItem("userData"))?.email}
                </div>
              </div>

              <button onClick={handleLogout} style={{ width: "100%", height: "42px", border: "none", background: "#fff", color: "#334155", cursor: "pointer", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", transition: "0.3s", }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f8fafc"; e.currentTarget.style.color = "#dc2626"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#fff"; e.currentTarget.style.color = "#334155"; }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Content */}
      <main className={`content ${isOpen ? "shift" : "nospace"}`}>
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="leads" element={<LeadManagement />} />
          <Route path="customers" element={<CustomerManagement />} />
          <Route path="orders" element={<SalesOrders />} />
          <Route path="SalesOrderList" element={<SalesOrderList />} />
          <Route path="orders/edit/:id" element={<SalesOrders />} />
          <Route path="category" element={<CategoryPage />} />
          <Route path="sheet-sheet" element={<SheetsMaster />} />
          <Route path="sheet-list" element={<ClothingSheetList />} />
          <Route path="products" element={<ProductMaster />} />
          <Route path="inventory" element={<InventoryMaster />} />
          <Route path="master+gst" element={<MasterGst />} />
          <Route path="quotations" element={<Invoicing />} />

          <Route path="invoicingvsm" element={<Invoicingvsm />} />
          <Route path="invoicelistvsm" element={<InvoicesListVsm />} />

          <Route path="invoicelist" element={<InvoicingList />} />
          <Route path="followups" element={<Followups />} />
          <Route path="roles" element={<UserRoles />} />
          <Route path="reports" element={<Reports />} />
          <Route path="logout" element={<Logout />} />
        </Routes>
      </main>
    </div>
  );
}

export default Dashboard;